import React from "react";
import IuManagementPageBase from "../../SHARED/components/IuManagementPageBase";
import {
  ADMIN_SYSTEM_MANAGEMENT_LINKS,
  IU_MANAGEMENT_PAGE_TITLE,
} from "../../SHARED/iuManagementPageConfig";

const AdminSystemManagement = () => (
  <IuManagementPageBase
    title={IU_MANAGEMENT_PAGE_TITLE.system}
    links={ADMIN_SYSTEM_MANAGEMENT_LINKS}
  />
);

export default AdminSystemManagement;
